import API from '../api-service';

const baseUri = 'sso';

export default {
  getSSOCredentials(userInfo) {
    return API.post(baseUri, userInfo);
  },
};
